export default function userRoles(userData) {
  const appRoles = getAppRoles(userData);
  const genRoles = getGeneralRoles(userData);
  const pubRoles = getPublisherRoles(userData);
  const agentRoles = getAgentRoles(userData);
  const testerRoles = getTesterRoles(userData);

  return [...appRoles, ...genRoles, ...pubRoles, ...testerRoles, ...agentRoles];
}

export function getAppRoles({ permissions: { appPermissions = {} } = {} }) {
  return Object.entries(appPermissions).map(([permTitle, permTarget]) => {
    if (permTarget.apps.length || permTarget.forAll) {
      return permTitle;
    }
  });
}

export function getGeneralRoles(args) {
  const {
    permissions: { generalPermissions = {} } = {},
    publisher: { verificationState, country } = {},
  } = args;
  const permissions = Object.keys(generalPermissions)
    .filter(perm => Boolean(generalPermissions[perm]))
    .filter(
      perm =>
        verificationState !== 'B' ||
        perm === 'viewFinanceInfo' ||
        perm === 'changeFinanceInfo',
    );
  if (country === 'IR') {
    permissions.push('iranian');
  } else {
    permissions.push('foreigner');
  }
  return permissions;
}

export function getPublisherRoles({ isPublisher, publisher = {} }) {
  const roles = [];

  if (isPublisher) {
    const publisherType =
      publisher.verificationState === 'B' ? 'blockedPublisher' : 'publisher';
    roles.push(publisherType);
  }

  publisher.isAdTester && roles.push('adTester');

  return roles;
}

export function getTesterRoles({
  publisher: { isDiscoveryTester, isBasicAdsTester } = {},
  isAdvertisementAdmin,
}) {
  const roles = [];

  if (isAdvertisementAdmin) {
    roles.push('adTester');
  }

  if (isDiscoveryTester) {
    roles.push('discoveryTester');
  }

  if (isBasicAdsTester) {
    roles.push('basicAdsTester');
  }

  return roles;
}

export function getAgentRoles({ isPublisher }) {
  const roles = [];

  if (!isPublisher) {
    roles.push('agent');
  }

  return roles;
}
